import { HttpClient, HttpClientModule } from '@angular/common/http';
import { DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule } from '@angular/core';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ElasticSearchService } from '@common/api-server';
import { ApiServerService } from '@common/api-server/api-server';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { NgxPermissionsModule } from 'ngx-permissions';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { translateBrowserLoaderFactory } from './core/settings/translate-browser.loader';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppLayoutModule } from './layout/app.layout.module';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import localeEs from '@angular/common/locales/es';
import { es, enGB } from 'date-fns/esm/locale'
import localeEnGb from '@angular/common/locales/en-GB';
import { DateFnsConfigurationService, DateFnsModule } from 'ngx-date-fns';
import { registerLocaleData } from '@angular/common';
import { ToastModule } from 'primeng/toast';

registerLocaleData(localeEs, es);
registerLocaleData(localeEnGb, enGB);
const spanishConfig = new DateFnsConfigurationService();
const enGBConfig = new DateFnsConfigurationService();
spanishConfig.setLocale(es);
enGBConfig.setLocale(enGB)

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AppLayoutModule,
    BrowserAnimationsModule,
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideAuth(() => getAuth()),
    provideFirestore(() => getFirestore()),
    HttpClientModule,
    NgxPermissionsModule.forRoot(),
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: translateBrowserLoaderFactory,
        deps: [HttpClient]
      }
    }),
    ConfirmDialogModule,
    ProgressSpinnerModule,
    ToastModule,

  ],
  providers: [
    { provide: LOCALE_ID, useValue: "es" },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR' },
    { provide: 'FIREBASE_REGION', useValue: environment.firebaseConfig.region },
    { provide: DateFnsConfigurationService, useValue: enGBConfig },
    DialogService,
    ApiServerService,
    MessageService,
    ConfirmationService,

    ElasticSearchService,

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
